
import React from 'react'
import { Link } from 'react-router';
import Select from 'react-select';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';

import UserSelect from '../Shared/UserSelect';
var Dropzone = require('react-dropzone');

class CIPForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      AuthorId : -1,
      Title : '',
      Description : '',
      CipGroupId : 0,
      State : 0,
      Valid : false,
      Files : [],
      FileCount : 0
    };
  }

  handleUserSelect(user){
    let state = Object.assign(this.state, {
        AuthorId : user ? user.Id : -1
    });
    let valid = this.canSubmit(state);
    this.setState({
      AuthorId : user ? user.Id : -1,
      Valid : valid
    });
  }

  handleCipGroupSelect(evt){
     let state = Object.assign(this.state, {
        CipGroupId : evt ? evt.Id : -1
    });
    let valid = this.canSubmit(state);
    this.setState({
      CipGroupId : evt ? evt.Id : -1,
      Valid : valid
    });
  }

  handleInputChange(propertyName, event) {
    if(typeof event === 'object'){
      let state = Object.assign(this.state, {
        [propertyName] : event.target.value
      });
      let valid = this.canSubmit(state);
      this.setState({
        [propertyName] : event.target.value,
        Valid : valid
      });
    }
    else{
      let state = Object.assign(this.state, {
        [propertyName] : event
      });
      let valid = this.canSubmit(state);
      this.setState({
        [propertyName] : event,
        Valid : valid
      });
    }
  }

  onDrop(acceptedFiles, rejectedFiles) {
      console.log('Accepted files: ', acceptedFiles);
      console.log('Rejected files: ', rejectedFiles);
      var files = this.state.Files; 
      files = files.concat(acceptedFiles);
      this.setState({
        Files : files,
        FileCount : files.length
      });
  }

  onFileUpload(event){
      this.setState({
        Files : event.target.files,
        FileCount : event.target.files.length
      });
  }

  canSubmit(){
    let state = this.state;
    var valid = state.AuthorId && state.Title && state.Description && (state.CipGroupId || state.CipGroupId == 0);
    return valid;
  }

  submit(){
    let onPostCipIdea = this.props.onPostCipIdea;
    this.setState({
      Loading : true
    });

    if(onPostCipIdea){
      onPostCipIdea(this.state).finally(() =>{
        this.setState({
          Loading : false,
          Saving : true
        });
      });
    }
  }
  
  render() {  
    const { cipGroups } = this.props;  
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
      
    return (
        <form>
                <div className="form-group">
                  <label>* {t('Name')}</label>
                  <UserSelect userId={this.state.AuthorId} onSelectUser={this.handleUserSelect.bind(this)}/>
                  <p className="help-block">{t('CIP.NAME.HELP')}</p>
                </div>
                <div className="form-group">
                  <label>* {t('CIP-Group')}</label>
                  <Select
                    value={this.state.CipGroupId}
                    options={cipGroups.Groups} onChange={this.handleCipGroupSelect.bind(this)}
                  />
                  <p className="help-block">{t('CIP.CI_GROUP.HELP')}</p>
                </div>
                <div className="form-group">
                  <label>* {t('Title')}</label>
                  <input className="form-control" onChange={this.handleInputChange.bind(this, 'Title')}/>
                  <p className="help-block">{t('CIP.TITLE.HELP')}</p>
                </div>
                <div className="form-group">
                  <label>* {t('Proposal')}</label>
                  <textarea rows="4" className="form-control" onChange={this.handleInputChange.bind(this, 'Description')}/>
                  <p className="help-block">{t('CIP.PROPOSAL.HELP')}</p>
                </div>
                <div className="form-group">
                  <label>{t('Attached files')}</label>
                  {
                  false && (<Dropzone onDrop={this.onDrop.bind(this)} className="dropzone-item" activeClassName="dropzone-item-active">
                      <div>Try dropping some files here, or click to select files to upload.</div>
                      <small>{this.state.FileCount} {t('file(s) attached !')}</small>
                  </Dropzone>)
                  }
                  <input className="form-control" type="file" onChange={this.onFileUpload.bind(this)} multiple/>
                  <p className="help-block">{t('ATTACH_FILES_HELP')}</p>
                </div>
                <button type="button" disabled={!this.state.Valid || this.state.Loading || this.state.Saving} onClick={this.submit.bind(this)} className="btn btn-default btn-brand pull-right">
                  { this.state.Loading && 
                    <i className="fa fa-refresh fa-spin" ></i>
                  }
                  &nbsp;
                  {t('Save and send')}</button>
      </form>
    );
  }
}

CIPForm.displayName = 'CIPForm';
CIPForm.propTypes = {};
CIPForm.defaultProps = {
  
};

export default injectIntl(CIPForm);









// WEBPACK FOOTER //
// ./components/MakeIdeas/CIPForm.js